<form autocomplete="on" class="space-y-6" (submit)="onLogin($event)">
  <!-- Header -->
  <div class="text-center">
    <!-- Subtle badge -->
    <div
      class="inline-flex items-center gap-1.5 px-3 py-1 rounded-full bg-blue-500/10 border border-blue-500/20 text-xs text-blue-400 mb-4"
    >
      <span class="relative flex h-1.5 w-1.5">
        <span
          class="animate-ping absolute inline-flex h-full w-full rounded-full bg-blue-400 opacity-75"
        ></span>
        <span class="relative inline-flex rounded-full h-1.5 w-1.5 bg-blue-500"></span>
      </span>
      Acceso seguro
    </div>

    <h2
      class="text-xl sm:text-2xl font-bold bg-linear-to-r from-white via-blue-100 to-cyan-200 bg-clip-text text-transparent"
    >
      Iniciar sesión
    </h2>
    <p class="mt-2 text-sm text-slate-400">Ingresa tus credenciales para acceder al panel</p>
    @if (errorLogin().length > 0) {
      <div
        class="mt-4 inline-flex items-center gap-2 px-4 py-2 rounded-lg bg-red-500/10 border border-red-500/20 text-sm text-red-400"
      >
        <i class="bi bi-exclamation-triangle-fill"></i>
        {{ errorLogin() }}
      </div>
    }
  </div>

  <!-- Decorative divider -->
  <div class="flex items-center gap-3">
    <div class="flex-1 h-px bg-white/5"></div>
    <svg
      class="w-4 h-4 text-slate-600"
      fill="none"
      viewBox="0 0 24 24"
      stroke="currentColor"
      stroke-width="2"
    >
      <path
        stroke-linecap="round"
        stroke-linejoin="round"
        d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z"
      />
    </svg>
    <div class="flex-1 h-px bg-white/5"></div>
  </div>
  <!-- Ruc -->
  <div class="flex flex-col gap-1.5 group">
    <label
      for="ruc"
      class="text-slate-300 text-sm group-focus-within:text-blue-400 transition-colors"
    >
      RUC
    </label>
    <input
      id="ruc"
      [formField]="loginForm.ruc"
      placeholder="12345678901"
      class="w-full pl-3 pr-3 py-2.5 border border-white/10 rounded-lg bg-white/5 text-white placeholder-slate-500 focus:border-blue-400 focus:ring-2 focus:ring-blue-500/20 outline-none transition-all duration-200 text-sm"
    />
  </div>
  <!-- Email field -->
  <div class="flex flex-col gap-1.5 group">
    <label
      for="email"
      class="text-slate-300 text-sm group-focus-within:text-blue-400 transition-colors"
    >
      Correo electrónico
    </label>
    <div class="relative">
      <span
        class="absolute left-3.5 top-1/2 -translate-y-1/2 text-slate-500 group-focus-within:text-blue-400 transition-colors"
        aria-hidden="true"
      >
        <svg class="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"
          />
        </svg>
      </span>
      <input
        id="email"
        type="email"
        placeholder="correo@ejemplo.com"
        [formField]="loginForm.email"
        autocomplete="email"
        class="w-full pl-10 pr-3 py-2.5 border border-white/10 rounded-lg bg-white/5 text-white placeholder-slate-500 focus:border-blue-400 focus:ring-2 focus:ring-blue-500/20 outline-none transition-all duration-200 text-sm"
      />
    </div>
  </div>

  <!-- Password field -->
  <div class="flex flex-col gap-1.5 group">
    <label
      for="password"
      class="text-slate-300 text-sm group-focus-within:text-blue-400 transition-colors"
    >
      Contraseña
    </label>
    <div class="relative">
      <span
        class="absolute left-3.5 top-1/2 -translate-y-1/2 text-slate-500 group-focus-within:text-blue-400 transition-colors"
        aria-hidden="true"
      >
        <svg class="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z"
          />
        </svg>
      </span>
      <!-- agregar un botón para mostrar/ocultar la contraseña -->
      <input
        id="password"
        [type]="showPassword() ? 'text' : 'password'"
        placeholder="••••••••"
        [formField]="loginForm.password"
        autocomplete="current-password"
        class="w-full pl-10 pr-3 py-2.5 border border-white/10 rounded-lg bg-white/5 text-white placeholder-slate-500 focus:border-blue-400 focus:ring-2 focus:ring-blue-500/20 outline-none transition-all duration-200 text-sm"
      />
      <button
        type="button"
        class="absolute right-3.5 top-1/2 -translate-y-1/2 text-slate-500 hover:text-blue-400 transition-colors"
        (click)="togglePasswordVisibility()"
        aria-label="Toggle password visibility"
      >
        <i class="bi" [class]="showPassword() ? 'bi-eye-slash' : 'bi-eye'"></i>
      </button>
    </div>
  </div>

  <!-- Actions row -->
  <div class="flex items-center justify-between">
    <label class="flex items-center gap-2 cursor-pointer select-none">
      <input
        type="checkbox"
        class="w-3.5 h-3.5 rounded border-white/20 bg-white/5 text-[#0080f3] focus:ring-[#0080f3]/30 focus:ring-offset-0 cursor-pointer"
        autocomplete="off"
        [formField]="loginForm.rememberMe"
        (input)="onChangeRecuerdame($event)"
      />
      <span class="text-xs text-slate-400">Recordarme</span>
    </label>
    <a
      routerLink="/auth/recuperar-cuenta"
      class="text-sm text-blue-400 hover:text-blue-300 transition"
    >
      ¿Olvidaste tu contraseña?
    </a>
  </div>

  <!-- Submit button -->
  <button
    type="submit"
    class="w-full py-3 bg-linear-to-r from-[#0080f3] to-[#0ea5e9] text-white font-semibold rounded-lg hover:shadow-lg hover:shadow-[#0080f3]/40 active:scale-[0.98] transition-all duration-200 text-sm"
  >
    Iniciar sesión
  </button>
</form>
